exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-row[data-v-36ecd47c] {\n  max-height: 60px;\n}\n", ""]);

// exports
